import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant'
import 'vant/lib/index.css'

import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'

import request from './utils/request'

Vue.use(Vant)
const options = {
  fullscreenEl: false
}
Vue.use(preview, options)
Vue.use(preview)

Vue.prototype.$http = request
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
